export default {
  errorsRootKey: 'invoice/way-to-pay',
  resource: 'invoice/way-to-pay',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
